import { render, staticRenderFns } from "./SideNavbar.vue?vue&type=template&id=b84bd46e"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"
import style0 from "./SideNavbar.vue?vue&type=style&index=0&id=b84bd46e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports